//
//
//
//
//

import { User } from '@/models'
import AV from 'leancloud-storage'

export default {
  name: 'wechatLogIn',
  created() {
    let code = this.$route.query.code
    let from = this.$route.query.state

    User.logInByQQ(code).then((data) => {
      let existed = data.existed

      if (existed) {
        AV.User.signUpOrlogInWithAuthData(data.authData, 'weixin').then(function(user) {
          this.$store.commit('logIn', user.toJSON())
          this.$router.push({ path: state || '/' })
        }).catch((err) => {
          this.$router.push({ path: state || '/' })
        })
      } else {
        let avatar = data.avatar
        let name = data.name
        let unionId = data.unionId
        let avatarFile = AV.File.withURL('avatar.png', avatar)

        AV.User.signUpOrlogInWithAuthData(data.authData, 'weixin').then(function(user) {
          return Promise.all([
            user,
            AV.Cloud.run('getNonRepetitiveUsername', { username: name }),
            avatarFile.save()
          ])
        }).then((data) => {
          let user = data[0]
          let name = data[1]
          let avatarFile = data[2]

          user.set('username', name)
          user.set('avatar', avatarFile)
          user.set('unionId', unionId)
          user.set('bindWechat', true)

          return user.save()
        }).then((user) => {
          this.$store.commit('logIn', user.toJSON())
          this.$router.push({ path: state || '/' })
        }).catch((err) => {
          this.$router.push({ path: '/' })
        })
      }
    }).catch((err) => {
      this.$router.push({ path: '/' })
    })
  },
  metaInfo: {
    title: '登录中...',
    titleTemplate: null
  },
  data() {
    return {
    }
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/pages/account/QQLogIn.vue